import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";

const glitchVariants = {
    initial: { opacity: 0, scale: 1.05, skewX: "-2deg" },
    animate: {
        opacity: 1,
        scale: 1,
        skewX: "0deg",
        transition: {
            duration: 0.8,
            ease: [0.43, 0.13, 0.23, 0.96],
        },
    },
    exit: {
        opacity: 0,
        scale: 0.98,
        skewX: "2deg",
        transition: { duration: 0.5 },
    },
};

const HomeAdvertisement = () => {
    const [cards, setCards] = useState([]);
    const navigate = useNavigate();

    const fetchAds = async () => {
        try {
            const response = await fetch(`https://100real.xyz/marquee/all/HBTR0003`);
            const res = await response.json();
            const today = new Date().toLocaleDateString("en-GB").split("/").reverse().join("-");

            const filteredAds = res.filter((ad) => {
                if (ad.status !== "Active") return false;
                if (ad.type === "Always") return true;
                if (ad.type === "End Date") return ad.date && ad.date >= today;
                return false;
            });

            setCards(filteredAds);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
    };

    useEffect(() => {
        fetchAds();
    }, []);

    if (cards.length === 0) return null;

    return (
        <div className="ad-slider-wrapper">
            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop={true}
                speed={800}
                allowTouchMove={true}
                className="ad-swiper"
            >
                {cards.map((card, index) => (
                    <SwiperSlide key={index}>
                        <motion.div
                            variants={glitchVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className="ad-slide"
                        >
                            <div className="ad-content">
                                <div>
                                    <h2 className="ad-heading">{card.heading}</h2>
                                    <p className="ad-description">{card.sub_heading}</p>
                                </div>
                                {card.link && (
                                    <button
                                        className="ad-button"
                                        onClick={() => window.open(card.link, "_blank")}
                                    >
                                        Know More
                                    </button>

                                )}
                            </div>
                        </motion.div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default HomeAdvertisement;
